module.exports = __webpack_public_path__ + "img/1540236107.9a3e94f0.jpg";